import ImageUtils from '../../lib/ImageUtils';
import valWithinBounds from './ValWithinBounds';
import {initZoomImageData} from './ZoomedImageBuilder';

export default function ZoomedImageDragging({selectedImage, getState, setState, onChange, rect = {width: 317, height: 336}}) {
	const imageSize = ImageUtils.naturalSize(selectedImage.src);
	return {
		onZoom: (zoom) => {
			if (!selectedImage.src) {
				return;
			}
			let currentZoom = selectedImage.zoom || 1.0;
			if (zoom === currentZoom) {
				return;
			}

			let {offsets} = initZoomImageData({
				imageSize,
				rect,
				selectedImage,
				zoom,
			});

			onChange({}, {
				selectedImage: {
					...selectedImage,
					...offsets,
				}
			});
		},
		onMouseDown: (event) => {
			event.preventDefault();
			if (!selectedImage.src) {
				return;
			}

			const {zoomedImage = {}} = getState();
			let zoom = selectedImage.zoom || 1.0;

			let {offsets,} = initZoomImageData({
				imageSize,
				rect,
				selectedImage,
				zoom,
			});

			setState({
				zoomedImage: {
					...zoomedImage,
					...offsets,
					initialX: offsets.x,
					initialY: offsets.y,
					dragging: true,
				}
			});
		},
		onMouseMove: (event) => {
			if (!selectedImage.src || (event.movementX === 0 && event.movementY === 0)) {
				return;
			}
			const {zoomedImage = {}} = getState();
			if (!zoomedImage.dragging) {
				return;
			}

			const zoom = selectedImage.zoom || 1.0;
			const lastPx = selectedImage.x ?? zoomedImage.initialX ?? 0;
			const lastPy = selectedImage.y ?? zoomedImage.initialY ?? 0;

			const negateIfNotZero = (a) => a === 0 ? 0 : -a;

			const possibleX = lastPx + negateIfNotZero(event.movementX);
			const possibleY = lastPy + negateIfNotZero(event.movementY);

			const x = valWithinBounds(possibleX, zoomedImage.minX, zoomedImage.maxX);
			const y = valWithinBounds(possibleY, zoomedImage.minY, zoomedImage.maxY);

			if (x !== selectedImage.x || y !== selectedImage.y) {
				onChange(event, {
					selectedImage: {
						...selectedImage,
						x,
						y,
						zoom,
					}
				});
			}
		},
		onMouseUp: (event) => {
			if (!selectedImage.src) {
				return;
			}
			const {zoomedImage} = getState();
			setState({
				zoomedImage: {
					...zoomedImage,
					dragging: false,
				}
			});
		},
		onMouseLeave: (event) => {
			if (!selectedImage.src) {
				return;
			}
			const {zoomedImage} = getState();
			setState({
				zoomedImage: {
					...zoomedImage,
					dragging: false,
				}
			});
		},
	};
}